import { render, staticRenderFns } from "./AddBrandShopDialog.vue?vue&type=template&id=35afd408&scoped=true"
import script from "./AddBrandShopDialog.vue?vue&type=script&lang=js"
export * from "./AddBrandShopDialog.vue?vue&type=script&lang=js"
import style0 from "./AddBrandShopDialog.vue?vue&type=style&index=0&id=35afd408&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35afd408",
  null
  
)

export default component.exports